package fyi.moko.hotpl.domain.usecase

import fyi.moko.hotpl.domain.model.Place
import fyi.moko.hotpl.domain.repository.PlaceRepository
import kotlinx.coroutines.flow.Flow

/** Streams a single place by id (null if it no longer exists). */
class ObservePlaceUseCase(
    private val repository: PlaceRepository,
) {
    operator fun invoke(id: String): Flow<Place?> = repository.observePlace(id)
}
